"use strict"; // Sh**t! I Smoke
// Copyright (C) 2018-2020  Marcelo S. Coelho, Amaury Martiny

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.isStationTooFar = exports.distanceToStation = exports.getCorrectLatLng = exports.MAX_DISTANCE_TO_STATION = void 0;

var haversine_1 = __importDefault(require("haversine"));
/**
 * Above this distance (km), we consider the station too far from the user
 */


exports.MAX_DISTANCE_TO_STATION = 10;
/**
 * Station given by the AQICN API is fucked up. Sometimes it's [lat, lng],
 * sometimes it's [lng, lat].
 * We check here with the user's real currentLocation coordinates, and take the
 * "closest" one.
 *
 * @param currentLocation - An object containing {latitude, longitude}
 * representing the user's current location.
 * @param station - An object containing {latitude, longitude} representing
 * the station's location.
 */

function getCorrectLatLng(currentLocation, station) {
  var d1 = Math.abs(currentLocation.latitude - station.latitude) + Math.abs(currentLocation.longitude - station.longitude);
  var d2 = Math.abs(currentLocation.latitude - station.longitude) + Math.abs(currentLocation.longitude - station.latitude);
  if (d1 < d2) return station;
  return __assign(__assign({}, station), {
    latitude: station.longitude,
    longitude: station.latitude
  });
}

exports.getCorrectLatLng = getCorrectLatLng;
/**
 * Get distance from current location to station.
 *
 * @param currentLocation - The current location of the user.
 * @param api - The api object returned by remote data.
 * @param unit - The unit of measure returned.
 */

function distanceToStation(currentLocation, pm25Measurement, unit) {
  if (unit === void 0) {
    unit = 'km';
  } // This case should be very rare, only happens on OpenAQ that sometimes,
  // the `coordinates` field isn't returned. This field is actually optional
  // in the OpenAQ format.
  // FIXME Return something better than 0?


  if (!pm25Measurement.coordinates) {
    return 0;
  }

  return Math.round(haversine_1["default"](currentLocation, getCorrectLatLng(currentLocation, pm25Measurement.coordinates), {
    unit: unit
  }));
}

exports.distanceToStation = distanceToStation;
/**
 * Returns true if the station is at more than {@link MAX_DISTANCE_TO_STATION}
 * kilometers away from the current location.
 *
 * @param currentLocation - The current location of the user.
 * @param api - The api object returned by remote data.
 */

function isStationTooFar(currentLocation, pm25Measurement) {
  return distanceToStation(currentLocation, pm25Measurement) > exports.MAX_DISTANCE_TO_STATION;
}

exports.isStationTooFar = isStationTooFar;